var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Modal', {
    attrs: {
      "title": "确认"
    },
    on: {
      "on-ok": _vm.verifyResetPassword
    },
    model: {
      value: _vm.resetPasswordModal,
      callback: function ($$v) {
        _vm.resetPasswordModal = $$v;
      },
      expression: "resetPasswordModal"
    }
  }, [_c('p', [_vm._v("你确定要重置" + _vm._s(_vm.selectUser && _vm.selectUser.name) + "的密码吗？")])]), _c('Modal', {
    attrs: {
      "title": "设置员工关联部门"
    },
    on: {
      "on-ok": _vm.submitChangeDepartment
    },
    model: {
      value: _vm.changeDepartmentModal,
      callback: function ($$v) {
        _vm.changeDepartmentModal = $$v;
      },
      expression: "changeDepartmentModal"
    }
  }, [_c('Tree', {
    attrs: {
      "data": _vm.selectTreeDepartmentData,
      "show-checkbox": ""
    },
    on: {
      "on-check-change": _vm.selectChangeDepart
    }
  })], 1), _c('Modal', {
    attrs: {
      "title": "设置员工关联工厂"
    },
    on: {
      "on-ok": _vm.submitChangeFactory
    },
    model: {
      value: _vm.changeFactoryModal,
      callback: function ($$v) {
        _vm.changeFactoryModal = $$v;
      },
      expression: "changeFactoryModal"
    }
  }, [_c('CheckboxGroup', {
    model: {
      value: _vm.selectFactoryData,
      callback: function ($$v) {
        _vm.selectFactoryData = $$v;
      },
      expression: "selectFactoryData"
    }
  }, _vm._l(_vm.factoryList, function (item) {
    return _c('Checkbox', {
      key: item._id,
      attrs: {
        "label": item._id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1), _c('Modal', {
    attrs: {
      "title": "修改用户密码",
      "width": "300"
    },
    on: {
      "on-ok": function ($event) {
        return _vm.submitChangePassword('changePasswordForm');
      }
    },
    model: {
      value: _vm.changePasswordModal,
      callback: function ($$v) {
        _vm.changePasswordModal = $$v;
      },
      expression: "changePasswordModal"
    }
  }, [_c('Form', {
    ref: "changePasswordForm",
    attrs: {
      "model": _vm.changePasswordForm,
      "rules": _vm.changePasswordValidate
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "请输入新密码",
      "prop": "newPassword"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "新密码"
    },
    model: {
      value: _vm.changePasswordForm.newPassword,
      callback: function ($$v) {
        _vm.$set(_vm.changePasswordForm, "newPassword", $$v);
      },
      expression: "changePasswordForm.newPassword"
    }
  })], 1)], 1)], 1), _c('Modal', {
    attrs: {
      "title": _vm.banned ? '恢复用户' : '禁用用户',
      "width": "300"
    },
    on: {
      "on-ok": function ($event) {
        return _vm.submitBannedUser();
      }
    },
    model: {
      value: _vm.bannedUserModal,
      callback: function ($$v) {
        _vm.bannedUserModal = $$v;
      },
      expression: "bannedUserModal"
    }
  }, [_c('div', [_vm._v("确认是否" + _vm._s(_vm.banned ? "恢复" : "禁用") + "此用户")])]), _c('Tabs', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "value": "name1",
      "animated": false
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "部门与员工",
      "name": "name1"
    }
  }, [_c('Row', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('Col', {
    staticClass: "department-panel",
    attrs: {
      "span": "6"
    }
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('h1', {
    staticStyle: {
      "margin-right": "auto"
    }
  }, [_vm._v("部门")]), _c('Button', {
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.openEditDepartmentDrawer();
      }
    }
  }, [_vm._v("新增部门")])], 1), _c('Input', {
    staticStyle: {
      "margin-bottom": "8px"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索部门"
    }
  }), _c('Tree', {
    attrs: {
      "data": _vm.treeDepartmentData,
      "show-checkbox": "",
      "render": _vm.renderContent
    },
    on: {
      "on-check-change": _vm.selectChange
    }
  })], 1), _c('Col', {
    staticClass: "user-panel",
    attrs: {
      "span": "18"
    }
  }, [_c('div', {
    staticClass: "userlist-wrapper"
  }, [_c('div', {
    staticClass: "selectBar"
  }, [_c('Input', {
    staticStyle: {
      "width": "250px",
      "margin-right": "30px"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索用户...",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchUser
    },
    model: {
      value: _vm.searchUserText,
      callback: function ($$v) {
        _vm.searchUserText = $$v;
      },
      expression: "searchUserText"
    }
  }), _c('Select', {
    staticStyle: {
      "width": "220px",
      "margin-right": "30px"
    },
    attrs: {
      "placeholder": "筛选角色",
      "label-in-value": "",
      "multiple": ""
    },
    on: {
      "on-change": _vm.choseRole
    },
    model: {
      value: _vm.selectRole,
      callback: function ($$v) {
        _vm.selectRole = $$v;
      },
      expression: "selectRole"
    }
  }, _vm._l(_vm.roleList, function (item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 1), _c('Checkbox', {
    on: {
      "on-change": _vm.searchUser
    },
    model: {
      value: _vm.selectSuperAdmin,
      callback: function ($$v) {
        _vm.selectSuperAdmin = $$v;
      },
      expression: "selectSuperAdmin"
    }
  }, [_vm._v("超级管理员")]), _c('Checkbox', {
    on: {
      "on-change": _vm.searchUser
    },
    model: {
      value: _vm.selectBannedUser,
      callback: function ($$v) {
        _vm.selectBannedUser = $$v;
      },
      expression: "selectBannedUser"
    }
  }, [_vm._v("禁用用户")])], 1), _c('div', {
    staticClass: "funBar"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.totalRows,
      "page-size": 20,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadUser
    }
  }), _vm.currentUser.superAdmin ? _c('Button', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.UploadFileModal.openModal();
      }
    }
  }, [_vm._v("导入员工")]) : _vm._e(), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.CreateUserDrawer.openDrawer();
      }
    }
  }, [_vm._v("创建员工")])], 1)]), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.tableData,
      "size": "small",
      "height": _vm.tableHeight
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function (_ref) {
        var row = _ref.row;
        return _vm.currentUser.superAdmin || _vm.arrayIntersection(['hr'], _vm.currentUser.simpleRole).length > 0 ? [_c('Dropdown', {
          attrs: {
            "trigger": "hover",
            "transfer": ""
          },
          on: {
            "on-click": _vm.clickActionDropDown
          }
        }, [_c('a', [_vm._v(" 操作 "), _c('Icon', {
          attrs: {
            "type": "ios-arrow-down"
          }
        })], 1), _c('DropdownMenu', {
          attrs: {
            "slot": "list"
          },
          slot: "list"
        }, [_c('div', [_c('DropdownItem', {
          attrs: {
            "name": `D ${row._id}`
          }
        }, [_vm._v("设置关联部门")]), _c('DropdownItem', {
          attrs: {
            "name": `F ${row._id}`
          }
        }, [_vm._v("设置关联工厂")]), _vm.currentUser.superAdmin ? _c('div', [_c('DropdownItem', {
          attrs: {
            "name": `P ${row._id}`
          }
        }, [_vm._v("修改密码")])], 1) : _vm._e(), _vm.currentUser.superAdmin ? _c('div', [_c('DropdownItem', {
          attrs: {
            "name": `R ${row._id}`
          }
        }, [_vm._v("重置密码")])], 1) : _vm._e(), _vm.currentUser.superAdmin ? _c('div', [_c('DropdownItem', {
          staticStyle: {
            "color": "#ed4014"
          },
          attrs: {
            "name": `B ${row._id}`
          }
        }, [_vm._v(" " + _vm._s(row.banned ? "恢复用户" : "禁用用户") + " ")])], 1) : _vm._e()], 1)])], 1)] : undefined;
      }
    }], null, true)
  })], 1)])], 1)], 1)], 1), _c('EditDepartmentDrawer', {
    ref: "EditDepartmentDrawer"
  }), _c('InviteUserDrawer', {
    ref: "InviteUserDrawer"
  }), _c('UploadFileModal', {
    ref: "UploadFileModal",
    on: {
      "uploadSuccess": _vm.loadUser
    }
  }), _c('CreateUserDrawer', {
    ref: "CreateUserDrawer",
    attrs: {
      "selectedDepart": _vm.selectedDepart
    },
    on: {
      "editSuccess": _vm.loadUser
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }